var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRacNewLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 132.041,
    height: 41.996,
    viewBox: "0 0 132.041 41.996",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.126,
    y1: 1.008,
    x2: 0.928,
    y2: 0.109,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.056,
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.998,
    stopColor: "#bfbfbf"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "RACPad_Logo",
    "data-name": "RACPad Logo",
    transform: "translate(19858.141 4480)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13423",
    "data-name": "Group 13423",
    transform: "translate(0 42)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12463",
    "data-name": "Group 12463",
    transform: "translate(-31963.945 -13992.164)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_37970",
    "data-name": "Path 37970",
    d: "M12139.89,9477.933c-1.6,1.416-26.6,24.9-26.6,24.9l14.49,7.668s15.948-30.118,15.948-30.523S12139.89,9477.933,12139.89,9477.933Z",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37971",
    "data-name": "Path 37971",
    d: "M12147.518,9498.859a14.229,14.229,0,0,1-4.935,9.709,13.384,13.384,0,0,1-6.263,3.013,23.437,23.437,0,0,1-6.622.535,7.6,7.6,0,0,1-2.338-.53,2.9,2.9,0,0,1-1.546-4.388c1.538-2.756,3.146-5.475,4.723-8.208l9.4-16.3a3.426,3.426,0,0,0,.066-3.718,3.1,3.1,0,0,0-3.088-1.584,5.163,5.163,0,0,0-1.87.7c-4.948,2.838-9.874,5.709-14.812,8.563-3.2,1.851-6.4,3.71-9.632,5.521a2.924,2.924,0,0,1-4.354-1.851,18.522,18.522,0,0,1-.408-4.391,21.089,21.089,0,0,1,.4-3.955,13.5,13.5,0,0,1,5.172-8.564,14.285,14.285,0,0,1,7.865-3c1.432-.093,2.865-.223,4.3-.23,5.193-.026,10.388-.019,15.582-.007a8.579,8.579,0,0,1,8.15,6.1,14.056,14.056,0,0,1,.447,3.411c.063,2.771.021,5.545.021,8.316C12147.8,9488,12147.782,9495.251,12147.518,9498.859Z",
    fill: "#3f7af5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37972",
    "data-name": "Path 37972",
    d: "M12109.278,9512.148c-.937,0-1.874-.016-2.812.006-.473.011-.672-.163-.662-.646.04-1.937.039-3.877.1-5.813a5.582,5.582,0,0,1,3.691-4.562,5.661,5.661,0,1,1,3.693,10.7,3.171,3.171,0,0,1-.873.256Z",
    fill: "#c3453b"
  })), /*#__PURE__*/React.createElement("text", {
    id: "RACPad",
    transform: "translate(-19805.1 -4494)",
    fontSize: 21,
    fontFamily: "ProximaNova-Bold, Proxima Nova",
    fontWeight: 700,
    letterSpacing: "0.005em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "RACPad"))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRacNewLogo);
export default __webpack_public_path__ + "static/media/RACNewLogo.cb531daa.svg";
export { ForwardRef as ReactComponent };